export default () => ({
    authUser: null
})